import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  HistoryLogin,
  HistoryLoginRequest,
  HistoryLoginResponse,
} from './types'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'

export const historyLoginsMounted = createEvent<HistoryLoginRequest>()

export const setHistoryLoginsRequestError = createEvent<RequestError>()

export const getHistoryLogins = fx<HistoryLoginRequest, HistoryLoginResponse>({
  method: 'GET',
  url: '/client/{clientId}/history_login',
})

export const $historyLogins = restore<HistoryLogin[]>(
  getHistoryLogins.doneData.map((doneData) => doneData.body.items),
  [],
)

export const $totalCountOfHistoryLogins = restore(
  getHistoryLogins.doneData.map((a) => a.body.total),
  0,
)

export const $errorHistoryLoginsRequest = restore(
  setHistoryLoginsRequestError,
  {
    message: '',
    code: 0,
  },
)

sample({
  clock: historyLoginsMounted,
  fn: ({ limit, page, sorterField }) => {
    let state = $params.getState()
    let query = {
      limit: String(limit),
      page: String(page),
      order: sorterField,
      where: JSON.stringify({ 'client.id': state?.clientID }),
    }
    return {
      query,
      url: `/client/${state?.clientID}/history_login`,
    }
  },
  target: getHistoryLogins,
})

sample({
  clock: getHistoryLogins.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setHistoryLoginsRequestError],
})
